import { useEffect, useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { onDemoNotice } from '../../config/demo';

// The popup shown whenever a write is refused in demo mode. Mounted once at the
// app root; every refusal — whether it came back from the API or was stopped in
// the browser — is published to it through config/demo.js.
export function DemoNotice() {
  const [notice, setNotice] = useState(null);

  useEffect(() => onDemoNotice(setNotice), []);

  const close = () => setNotice(null);

  return (
    <Modal open={!!notice} onClose={close} title={notice?.title || ''} size="md">
      <div className="flex gap-4">
        <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400">
          <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6">
            <path d="M10 7v4M10 14h.01" strokeLinecap="round" />
            <circle cx="10" cy="10" r="7.25" />
          </svg>
        </div>
        <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300">{notice?.body}</p>
      </div>
      <div className="mt-6 flex justify-end">
        <Button onClick={close}>Got it</Button>
      </div>
    </Modal>
  );
}
